import gql from 'graphql-tag'

export const GET_ALL_MEMBERSHIP_USERS = gql`
  query GetAllMembershipUsers($organizationSlug: String!) {
    getAllMembershipUsers(organizationSlug: $organizationSlug) {
      id
      name
      createdAt
      code
      validUntil
      membershipPlan {
        name
        from
        to
      }
    }
  }
`

export const GET_ALL_MEMBERSHIP_USERS_BY_MEMBERSHIP_PLAN = gql`
  query GetAllMembershipUsersByPlan($organizationSlug: String!, $planId: ID!) {
    getAllMembershipUsersByPlan(planId: $planId, organizationSlug: $organizationSlug) {
      id
      name
      email
    }
  }
`

export const GET_ALL_SPORT_MEMBERSHIP_USERS_WITH_PAGINATION = gql`
  query GetAllMembershipUsersWithPagination(
    $organizationSlug: String!
    $pagination: Pagination!
    $searchTerm: String
    $membershipPlanId: ID
  ) {
    getAllMembershipUsersWithPagination(
      organizationSlug: $organizationSlug
      pagination: $pagination
      searchTerm: $searchTerm
      membershipPlanId: $membershipPlanId
    ) {
      items {
        id
        name
        createdAt
        qrcode
        fields
        validUntil
        membershipPlan {
          id
          name
          from
          to
        }
      }
      totalCount
    }
  }
`

export const GET_SPORT_MEMBERSHIP_REQUESTS = gql`
  query GetSportMembershipRequests(
    $organizationSlug: String!
    $pagination: Pagination!
    $searchTerm: String
    $membershipPlanId: ID
    $status: String
  ) {
    getSportMembershipRequests(
      organizationSlug: $organizationSlug
      pagination: $pagination
      searchTerm: $searchTerm
      membershipPlanId: $membershipPlanId
      status: $status
    ) {
      items {
        id
        name
        createdAt
        fields
        membershipPlan {
          id
          name
        }
      }
      totalCount
    }
  }
`

export const GET_ALL_MEMBERSHIP_USERS_WITH_PAGINATION = gql`
  query GetAllMembershipUsersWithPagination(
    $organizationSlug: String!
    $pagination: Pagination!
    $searchTerm: String
  ) {
    getAllMembershipUsersWithPagination(
      organizationSlug: $organizationSlug
      pagination: $pagination
      searchTerm: $searchTerm
    ) {
      items {
        id
        name
        createdAt
        code
        validUntil
        fields
        membershipPlan {
          name
          from
          to
        }
      }
      totalCount
    }
  }
`

export const CREATE_SPORT_MEMBERSHIP_USER = gql`
  mutation CreateSportMembershipUser($dto: UserSportMembershipUserInput!) {
    createSportMembershipUser(dto: $dto)
  }
`

export const CREATE_PUBLIC_SPORT_MEMBERSHIP_REQUEST = gql`
  mutation CreatePublicSportMembershipRequest($dto: UserSportMembershipUserInput!) {
    createPublicSportMembershipRequest(dto: $dto)
  }
`

export const UPDATE_SPORT_MEMBERSHIP_USER = gql`
  mutation UpdateSportMembershipUser($id: ID!, $dto: UserSportMembershipUserInput!) {
    updateSportMembershipUser(id: $id, dto: $dto)
  }
`

export const UPDATE_MEMBERSHIP_REQUEST_STATUS = gql`
  mutation UpdateMembershipRequestStatus(
    $membershipUserId: ID!
    $organizationSlug: String!
    $status: String!
  ) {
    updateMembershipRequestStatus(
      membershipUserId: $membershipUserId
      organizationSlug: $organizationSlug
      status: $status
    )
  }
`

export const GET_SPORT_MEMBERSHIP_USER = gql`
  query GetMembershipUserById($id: ID!) {
    getMembershipUserById(id: $id) {
      fields
      name
      email
      qrcode
      membershipPlanId
    }
  }
`

export const GET_TOTAL_SPORT_MEMBERSHIP_USERS_SOLD_DATA = gql`
  query GetTotalSportMembershipUsersSoldData(
    $organizationSlug: String!
    $membershipPlanId: ID
    $purchaseSource: String
  ) {
    getTotalSportMembershipUsersSoldData(
      organizationSlug: $organizationSlug
      membershipPlanId: $membershipPlanId
      purchaseSource: $purchaseSource
    ) {
      soldItems
      totalIncome
    }
  }
`

export const GET_MEMBERSHIP_USERS_GROUPED_BY_CREATED_AT_DATE = gql`
  query GetMembershipUsersGroupedByCreatedAtDate(
    $organizationSlug: String!
    $membershipPlanId: ID
    $startDate: String
    $endDate: String
    $purchaseSource: String
  ) {
    getMembershipUsersGroupedByCreatedAtDate(
      organizationSlug: $organizationSlug
      membershipPlanId: $membershipPlanId
      startDate: $startDate
      endDate: $endDate
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_MEMBERSHIP_USERS_GROUPED_BY_CREATED_AT_MONTH = gql`
  query GetMembershipUsersGroupedByCreatedAtMonth(
    $organizationSlug: String!
    $membershipPlanId: ID
    $startDate: String
    $endDate: String
    $purchaseSource: String
  ) {
    getMembershipUsersGroupedByCreatedAtMonth(
      organizationSlug: $organizationSlug
      membershipPlanId: $membershipPlanId
      startDate: $startDate
      endDate: $endDate
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_MEMBERSHIP_USERS_GROUPED_BY_MEMBERSHIP_PLAN_ID = gql`
  query GetMembershipUsersGroupedByMembershipPlanId(
    $organizationSlug: String!
    $membershipPlanId: ID
    $purchaseSource: String
  ) {
    getMembershipUsersGroupedByMembershipPlanId(
      organizationSlug: $organizationSlug
      membershipPlanId: $membershipPlanId
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_MEMBERSHIP_USERS_CUMULATIVE_INCOME_GROUPED_BY_CREATED_AT_DATE = gql`
  query GetMembershipUsersCumulativeIncomeGroupedByCreatedAtDate(
    $organizationSlug: String!
    $membershipPlanId: ID
    $startDate: String
    $endDate: String
    $purchaseSource: String
  ) {
    getMembershipUsersCumulativeIncomeGroupedByCreatedAtDate(
      organizationSlug: $organizationSlug
      membershipPlanId: $membershipPlanId
      startDate: $startDate
      endDate: $endDate
      purchaseSource: $purchaseSource
    )
  }
`
